export default __webpack_public_path__ + "static/media/ausis-cover-img.5cf19b55.png";